import { useAlertSettings } from "./useAlertSettings";

/**
 * Settings > Dashboard home > "Make HP Regulation the home page" (org-wide, on by default). On: the chat is the landing page and
 * "Overview" and the floating HP Genie button are hidden (a direct /overview URL still opens). `ready` is false until the setting
 * has loaded, so the home route does not flash the wrong page. Shares the settings query's cache.
 */
export function useRegulationHome(): { regulationHome: boolean; ready: boolean } {
  const settings = useAlertSettings();
  // If the setting cannot be loaded, fall back to the default (on) rather than blocking the app.
  const ready = !settings.isPending;
  return { regulationHome: settings.data ? settings.data.regulation_home !== false : true, ready };
}
